import { makeAutoObservable, flow } from 'mobx'

import * as srv from 'admin/services'
import handleError from 'admin/services/error-handler'

export default class PriceCategoryStore {
  loading = false
  processing = false
  dialog = {
    form: false,
    delete: false,
  }
  selected = null
  list = []
  total = 0

  DEFAULT = {
    label: '',
    items: [],
    allPriceCategory: [],
  }

  constructor(rootStore) {
    makeAutoObservable(this, {
      reload: flow,
      fetch: flow,
    })
    this.rootStore = rootStore
  }

  setOpenDialog = (selected, type) => {
    this.dialog[type] = true
    if (selected) {
      this.selected = { ...this.DEFAULT, ...selected }
    } else {
      this.selected = { ...this.DEFAULT }
    }
  }

  setCloseDialog = (type, reset = true) => {
    this.dialog[type] = false
    if (reset) setTimeout(this.resetSelected, 50)
  }

  setSelected = (value) => {
    this.selected = value
  }

  updateSelected = (key, value) => {
    this.selected = { ...this.selected, [key]: value }
  }

  * reload(reset = false) {
    yield this.fetch()
    if (reset || !this.list.length) {
      this.selected = { ...this.DEFAULT }
    }
  }

  * fetch() {
    try {
      this.loading = true
      const response = yield srv.fetchPriceCategory()
      if (response.ok) {
        this.list = response.data.list
        this.total = response.data.total
        return response.data
      }
      throw handleError(response)
    } catch (error) {
      return null
    } finally {
      this.loading = false
    }
  }
}
